import type { RouteObject } from 'react-router';

import { UsersPage } from './Users';

/**
 * `/users` — the account register. One `RouteObject`, so the file is
 * `.route.tsx` singular; the feature's two routes are aggregated in
 * `users.routes.tsx` one level up.
 *
 * It sits inside the console layout route, which already runs the guard chain —
 * `sessionInMemory? → silentRefreshOnceOn401 → me() → roleGate` — so the route
 * adds no loader of its own.
 *
 * **The guard admits an `operator`, and that is not the same as admitting every
 * action on the page.** `backend-auth` opens the roster read to `operator` and
 * reserves block, unblock, and role grant for `admin`; the console does not
 * pre-compute that outcome, renders the menu entry as written, and lets the
 * owning service refuse with `403 AUTH_ROLE_REQUIRED` — which the error catalog
 * turns into a sentence naming who can do it instead. Hiding the entry would
 * make «not allowed» indistinguishable from «not shown here».
 *
 * The role facet lives in the URL (`?role=`), so a filtered register is a
 * shareable address and the browser's back button walks the filter.
 */
export const usersRoute: RouteObject = {
  path: 'users',
  element: <UsersPage />,
};
